import React, { useEffect, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { useTranslate } from 'react-admin';

const useStyles = makeStyles(theme => ({
  removeButton: {},
  removeIcon: {
    color: theme.palette.error.main
  }
}));

interface Props {
  children: ReactNode;
  className?: string;
  onRemove: () => void;
  file: any;
}

const FileInputPreview = (props: Props) => {
  const { children, className, onRemove, file, ...rest } = props;
  const classes = useStyles(rest);
  const translate = useTranslate();

  useEffect(() => {
    return () => {
      const preview = file.rawFile ? file.rawFile.preview : file.preview;

      if (preview) {
        window.URL.revokeObjectURL(preview);
      }
    };
  }, [file]);

  return (
    <div className={className} {...rest}>
      {children}
      <IconButton
        className={classes.removeButton}
        onClick={onRemove}
        aria-label={translate('ra.action.delete')}
        title={translate('ra.action.delete')}
      >
        <Clear className={classes.removeIcon} />
      </IconButton>
    </div>
  );
};

FileInputPreview.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  file: PropTypes.object,
  onRemove: PropTypes.func.isRequired
};

FileInputPreview.defaultProps = {
  file: undefined
};

export default FileInputPreview;
